export interface Game {
    casino_provider_id: number;
    casino_providers_name: string;
    created_at: string;
    game_id: string;
    id: number;
    name: string;
    updated_at: string;
    game_name_id: string;
}
